import { AI_NOTE_SUMMARY_FOR_PROFILE } from "graphql/queries";
import useQueryData from "hooks/useQueryData";

const keyName = "aiNoteSummaryForProfile";

/**
 * useProfileNoteAiSummary
 *
 * @param {string} profileId - The ID of the profile to fetch the AI summary for.
 */
export default function useProfileNoteAiSummary({ profileId }) {
  const { data, loading, error } = useQueryData({
    queryName: AI_NOTE_SUMMARY_FOR_PROFILE,
    keyName,
    variables: { profileId },
    skip: !profileId,
  });

  return {
    data: data?.[keyName]?.summary,
    summaryHash: data?.[keyName]?.summaryHash,
    loading,
    error,
  };
}
